import { useLingui } from '@lingui/react';

import { ServiceType } from '@rover/constants/src/translations/service.constants';
import { PetType } from '@rover/types/src/Pet';
import type { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';
import {
  getIsPriceTransparencyFull,
  getIsPriceTransparencyLite,
} from '@rover/utilities/priceTransparency';

import { getBookingFeeLearnMoreUrl } from '../../../utils/bookingFeeUtils';
import { BookingFeeLinkClickSeoEvent } from '../../search/SearchPage/components/analyticsEvents';
import {
  AlertContentEnum,
  getAlertContent,
} from '../../search/SearchPage/components/SearchSectionHeader/builders/constants';
import { getTextElement } from '../../search/SearchPage/components/SearchSectionHeader/SearchSectionHeader';
import { getAlertElement } from '../../search/SearchPage/components/SearchSectionHeader/SearchSectionHeader.common';
import { SeoLocationPageProps } from '../SeoLocation/types';

type Props = {
  priceTransparencyLevel: PriceTransparencyLevel;
  serviceType: ServiceType;
  countryConfig: SeoLocationPageProps['countryConfig'];
  petType?: PetType;
};

const PriceTransparencySubheading: React.FC<Props> = ({
  priceTransparencyLevel,
  serviceType,
  countryConfig,
  petType,
}: Props) => {
  const { i18n } = useLingui();
  let alertText;
  if (getIsPriceTransparencyFull(priceTransparencyLevel)) {
    alertText = getAlertContent(AlertContentEnum.PRICE_TRANSPARENCY_FULL_SEO_PAGE, {
      i18n,
      serviceType,
      bookingFeePercentage: countryConfig.bookingFeePercentage,
      petType,
    });
  } else if (getIsPriceTransparencyLite(priceTransparencyLevel)) {
    alertText = getAlertContent(AlertContentEnum.PRICE_TRANSPARENCY_LITE_SEO_PAGE, {
      i18n,
      serviceType,
      bookingFeePercentage: countryConfig.bookingFeePercentage,
    });
  }

  return getAlertElement(
    alertText,
    getBookingFeeLearnMoreUrl(countryConfig.urls),
    new BookingFeeLinkClickSeoEvent(),
    getTextElement,
    { asParagraph: false }
  );
};

export default PriceTransparencySubheading;
